var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.modalClasses },
    [
      _c("i", { staticClass: "close icon" }),
      _vm._v(" "),
      _vm._t("header", function() {
        return [
          _vm.title
            ? _c("div", { staticClass: "header" }, [
                _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
              ])
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c("div", { class: _vm.contentClasses }, [
        _vm.icon
          ? _c("div", { staticClass: "ui medium image" }, [
              _c("i", { staticClass: "user icon" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [_vm._t("default")], 2)
      ]),
      _vm._v(" "),
      _vm._t("actions", function() {
        return [
          _vm.approve || _vm.deny
            ? _c("div", { staticClass: "actions" }, [
                _c("div", { staticClass: "ui deny button" }, [
                  _vm._v("\n                Cancel\n            ")
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ui yellow approve right labeled icon button" },
      [
        _vm._v("\n                Continue\n                "),
        _c("i", { staticClass: "checkmark icon" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35434564", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35434564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Popup.vue
// module id = c9bJ
// module chunks = 1